<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'General' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <broker-general />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Deposits' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <broker-deposits />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-link-2" :label="!isSmallerScreen ? 'Bank limits' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <broker-bank-limits />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-bell" :label="!isSmallerScreen ? 'Accounts' : ''">
      <div class="tab-text md:ml-4 md:mt-0 mt-4 ml-0">
        <broker-accounts />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import BrokerGeneral from "./BrokerGeneral.vue"
import BrokerDeposits from "./BrokerDeposits.vue"
import BrokerBankLimits from "./BrokerBankLimits.vue"
import BrokerAccounts from "./BrokerAccounts.vue"

export default {
  components: {
    BrokerGeneral,
    BrokerDeposits,
    BrokerBankLimits,
    BrokerAccounts,
  },
  data() {
    return {

    }
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
